// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';

import {
  mx, px, pr, pb, mb, mt, mr
} from 'styled-components-spacing';

import breakpoint from 'styled-components-breakpoint';

import { MobileFiltersPreview } from '@components/MobileFilters';
import theme from '@theme';

const { colors } = theme;

export const StyledWrapper = styled.div`
  max-width: 1500px;

  position: relative;
  width: 100%;

  ${px(3)}

  ${breakpoint('desktop')`
    ${px(5)}
  `}

  box-sizing: border-box;
  -moz-box-sizing: border-box;
`;

export const StyledHeadlineText = styled(Grid)`
  justify-content: space-between;
  align-items: flex-start;

  border-bottom: 2px solid ${colors.translucentDarkBlue};

  ${mb(3)}

  display: flex;
  flex-direction: row;

  width: 100%;

  & > h1 {
    font-size: 28px;
    font-weight: 600;
    color: ${colors.darkBlue};
    ${mb(2)}
    ${pr(1)}
    ${pb(1)}
    ${breakpoint('desktop')`
      ${mb(3)}
    `}
  }

  & > p {
    font-size: 18px;
    font-weight: 400;
    line-height: 34px;
    color: ${colors.darkBlue};
    ${pb(1)}
    ${breakpoint('mobile', 'tablet')`
      ${pb(3)}
    `}
  }

  ${breakpoint('desktop')`
    ${mb(4)}
    ${mt(5)}
    ${pb(2)}
  `}
`;

export const StyledH1Container = styled.h1`
  display: flex;
  justify-content:left;
  align-items:left;
  line-height: 1.4;
`;

export const StyledList = styled(Grid)`
  ${mx(-3)}
  min-height: 50vh;
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
`;

export const StyledMobileFiltersPreview = styled(MobileFiltersPreview)`
  ${mx(-3)}
`;

export const StyledResultFilter = styled.div`
  display: flex;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
     width:100%;
     justify-content: flex-end;
  `}
`;


export const StyledResetFilter = styled.button`
  background-color: white;
  color: #57a1bb;
  text-decoration: underline;
  ${mr(3)}
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  border: none;
  border-radius: 5px;
  padding: 0px 10px;
  cursor: pointer;
`;
